import http from "@/http-common"
import type { DestinationProviderScope } from "@/static/Space"

class DestinationProviderDataService {
  getDestinationProviders(scope?: DestinationProviderScope, tourismInformationCenterId?: number | null): Promise<any> {
    return http.get(`/auth/destination-providers`, {
      params: {
        scope: scope,
        tourism_information_center_id: tourismInformationCenterId,
      },
    })
  }

  getDestinationProvider(id: number): Promise<any> {
    return http.get(`/auth/destination-providers/${id}`)
  }

  getOpenFormIframeUrl(id: number): Promise<any> {
    return http.get(`/auth/destination-providers/${id}/open-form`)
  }

  getTourismInformationCenters(): Promise<any> {
    return http.get(`/auth/destination-providers/tourism-information-centers`)
  }
}

export default new DestinationProviderDataService()
